export function getBrand() {
    var circleloop = "circleloop";
    var cloudtalk = "cloudtalk";

    if (!process.env.REACT_APP_BRAND) return circleloop;
    var brand = process.env.REACT_APP_BRAND.toLowerCase();
    if (brand === 'circleloop') return circleloop;
    if (brand === 'cloudtalk') return cloudtalk;
    else return circleloop;
}

export function getIntegrationName(name){
    return name.slice(name.length-3) === 'Dev' ? name.slice(0,name.length-3) : name;
}


// WEBPACK FOOTER //
// ./src/utils.js